import { ErrorInfo } from 'react';

import * as errorStackParser from 'error-stack-parser';
import StackTraceGPS from 'stacktrace-gps';

export namespace GuiServer {
  export const fetchConfiguration = async (): Promise<Response> => fetch(`${process.env.PUBLIC_URL}/configuration`);

  export const postError = async (error: Error, errorInfo?: ErrorInfo | null): Promise<Response> => {
    const stackTraceGPS = new StackTraceGPS();
    const enhancedStack = errorInfo
      ? await Promise.all(
          errorStackParser.parse(error).map(async (frame) => await stackTraceGPS.getMappedLocation(frame))
        )
      : undefined;

    return fetch(`${process.env.PUBLIC_URL}/clientlog`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: error.name,
        message: error.message,
        url: window.location.href,
        stack: enhancedStack,
        componentStack: errorInfo?.componentStack || undefined,
        userAgent: window.navigator.userAgent
      })
    });
  };
}

export default GuiServer;
